export default __webpack_public_path__ + "static/media/gallery_03.33b519bd.jpg";